import React from 'react';
import contactUsImage from '../assets/images/contact-us.svg';
const SupportPage: React.FC = () => {
  return (
    <div className="flex justify-between gap-4 items-center mx-5 bg-white border rounded-md">
      <div className="flex-1 flex items-center p-5">
        <div className="grid gap-2">
          <div className="text-2xl font-bold"> Unterstützung </div>
          <div className="flex gap-4 border-b pb-4 mb-4">
            <div className="text-md ">
              Bei Bedarf an Unterstützung können Sie uns telefonisch während der
              Geschäftszeiten und per E-Mail die ganze Woche über erreichen.
            </div>
          </div>
          <div className="flex gap-4">
            <div className="text-gray-500">Email</div>
            <div className="font-medium">
              <a
                href="mailto:support@pccaddie-online.de"
                className="font-medium text-[#52A445]"
                title="Send an email to support@pccaddie-online.de"
              >
                support@pccaddie-online.de
              </a>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="text-gray-500">Fon</div>
            <div className="font-medium">+49 2642 9854120</div>
          </div>
        </div>
      </div>
      <div className="hidden md:inline-block ">
        <img
          alt="contactUs"
          className="w-[450px] rounded-r-md animate__animated animate__fadeIn animate__faster"
          src={contactUsImage}
        />
      </div>
    </div>
  );
};

export default SupportPage;
